import { TEAM_SIZE_OPTIONS } from './onboarding-checklist/team-size.util';

export const superseeConfig = {
    teamSizeOptions: TEAM_SIZE_OPTIONS.map((option) => ({
        value: option.value,
        label: option.label,
    })),
};
